/**
 * 认证相关 Mixin
 */
import { 
  isAuthenticated, 
  getUserId, 
  getAccessToken, 
  clearAuth 
} from '@/utils/storage'
import { requireAuth } from '@/utils/auth'

export default {
  data() {
    return {
      userinfo: null,
      isAuthenticated: false
    }
  },
  computed: {
    currentUser() {
      return getUserId()
    },
    hasToken() {
      return !!getAccessToken()
    }
  },
  mounted() {
    this.updateAuthState()
  },
  methods: {
    /**
     * 更新认证状态
     */
    updateAuthState() {
      this.userinfo = getUserId()
      this.isAuthenticated = isAuthenticated()
    },
    
    /**
     * 检查认证（如果未认证则跳转到登录页）
     * @param {string} message - 提示消息
     * @returns {boolean} 是否已认证
     */
    checkAuth(message = '请先登录') {
      return requireAuth(this, message)
    },
    
    /**
     * 退出登录
     */
    logout() {
      // 清除认证信息
      clearAuth()
      
      // 更新状态
      this.updateAuthState()
      
      // 跳转到登录页
      if (this.$router) {
        this.$router.push({ name: 'login' })
      }
    }
  }
}

